var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "nz_toggle_wrap",
      staticClass: "nz-toggle-wrap",
      class: _vm.getStyle(),
      style: _vm.wrapStyle(),
      attrs: { disabled: _vm.disabled }
    },
    [
      _c("div", { staticClass: "nz-toggle" }, [
        _c("div", { ref: "nz_toggle_handle", staticClass: "nz-toggle-handle" })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }